/* 
assets/wpx-variation-images.js
Loaded inside /layout/theme.liquid with <script src="{{ 'wpx-variant-images.js' | asset_url }}" defer></script>
Based on the selected variation, hide the image that is not the featured image. Show all th others.
*/
document.addEventListener('DOMContentLoaded', () => {
  const scroller = document.querySelector('.product__thumbs--scroller');
  if (!scroller) return;

  const currentVariantId = scroller.getAttribute('data-variant-id');
  const thumbs = scroller.querySelectorAll('.product__thumb-item');

  thumbs.forEach(thumb => {
    const thumbVariantId = thumb.getAttribute('data-variant-id');

    // Always show if no variant-specific binding
    if (!thumbVariantId) {
      thumb.style.display = '';
    } else if (thumbVariantId === currentVariantId) {
      thumb.style.display = '';
    } else {
      thumb.style.display = 'none';
    }
  });
});